import { render, staticRenderFns } from "./comparequarter.vue?vue&type=template&id=3ed40962&scoped=true&"
import script from "./comparequarter.vue?vue&type=script&lang=js&"
export * from "./comparequarter.vue?vue&type=script&lang=js&"
import style0 from "./comparequarter.vue?vue&type=style&index=0&id=3ed40962&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed40962",
  null
  
)

export default component.exports